export default "__VITE_ASSET__CbReJzkm__"